var map = {
	"./css.svg": 900,
	"./html.svg": 956,
	"./javascript.svg": 130,
	"./laravel.svg": 826,
	"./mysql.svg": 987,
	"./nodejs.svg": 466,
	"./php.svg": 113,
	"./react.svg": 624,
	"./sass.svg": 265,
	"./vue.svg": 213,
	"./wordpress.svg": 920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 599;